module.exports = __webpack_public_path__ + "static/media/anobis-group-central.9a433f59.svg";